var map = {
	"./background.png": "30b3",
	"./banner.png": "ec24",
	"./consumer.png": "e5ed",
	"./error.png": "1fe8",
	"./logo.png": "cf05",
	"./mindmap.png": "2d50",
	"./parallel.png": "af46",
	"./provider.png": "2504",
	"./serial.png": "c0fd",
	"./wirediameter.png": "b86d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b9";